module.exports = __webpack_public_path__ + "img/Serbia.8e833508.png";